import {DialogFragment, PageFragment, PageFragmentProps, PageFragmentState} from "./PageFragment";
import React from "react";
import {StyledBoxColumn, StyledBoxRow, StyledSpan} from "./StyledComponents";
import {DIVIDER, PD_MD} from "./dimens";
import {Button, Step, StepButton, Stepper} from "@mui/material";
import {FormGenContainer, FormGenContainerMode} from "./FormGenContainer";
import {BaseApp} from "./BaseApp";
import {Action} from "./types";

export enum FormGenMultiStepFragmentMode {
  CREATE,
  EDIT,
}

export type FormGenMultiStepConfigStep = {
  text: string,
}

export type FormGenMultiStepConfig = {
  mode?: FormGenMultiStepFragmentMode,
  title: string,
  actions?: Action[],
  finishAction: Action,
  steps: FormGenMultiStepConfigStep[],
}

export type FormGenMultiStepFragmentProps<T> = PageFragmentProps & {
  object: T,
  config: FormGenMultiStepConfig,
  hideDialog?: boolean,
  draft?: boolean,
  containerMode?: FormGenContainerMode,
}

type FormGenMultiStepFragmentState = PageFragmentState & {
  currentIndex: number,
  hasUnfilledRequiredItems?: boolean,
}

export class FormGenMultiStepFragment<T, P extends FormGenMultiStepFragmentProps<T> = FormGenMultiStepFragmentProps<T>, S extends FormGenMultiStepFragmentState = FormGenMultiStepFragmentState> extends DialogFragment<P, S> {

  protected onCreateState(): S {
    return {
      ...super.onCreateState(),
      currentIndex: 0,
    };
  }

  protected getTitle(): string | null | undefined {
    return this.props.config.title;
  }

  renderContent(): React.ReactElement {
    return <StyledBoxColumn style={{position: "relative", flexGrow: 1}}>
      <StyledBoxRow style={{width: "100%", overflowX: "scroll", borderBottom: DIVIDER, padding: PD_MD}}>
        <Stepper nonLinear activeStep={this.state.currentIndex}>
          {this.props.config.steps.map((step, index) => (
            <Step key={step.text} completed={index < this.state.currentIndex}>
              <StepButton disabled={index > this.state.currentIndex} color="inherit" onClick={() => {
              }}>
                {step.text}
              </StepButton>
            </Step>
          ))}
        </Stepper>
      </StyledBoxRow>
      <StyledBoxColumn style={{height: 0, flexGrow: 1, overflowY: "scroll"}}>
        <FormGenContainer
          key={`formgen-multistep-${this.state.currentIndex}`}
          multiStep
          multiStepIndex={this.state.currentIndex}
          onContainerRequiredItemsFilledChanged={(container: FormGenContainer, filled: boolean) => {
            this.setState({
              hasUnfilledRequiredItems: !filled,
            });
          }}
          content={this.props.object}/>
      </StyledBoxColumn>
      <StyledBoxRow style={{padding: PD_MD, borderTop: DIVIDER}}>
        {this.state.currentIndex > 0
          ? <Button
            variant={"contained"}
            onClick={() => {
              this.setState({currentIndex: this.state.currentIndex - 1})
            }}>Back</Button>
          : null}
        <StyledSpan/>
        {this.props.config.actions?.map((action: Action) => PageFragment.renderPageToolbarButtonEx(action))}
        {this.props.config.mode === FormGenMultiStepFragmentMode.EDIT
          ? <Button
            variant={"contained"}
            disabled={!this.props.draft && this.state.hasUnfilledRequiredItems}
            onClick={() => {
              if (this.props.hideDialog) {
                BaseApp.CONTEXT.hideDialog();
              }
              this.props.config.finishAction.onClick();
            }}>{`${this.props.hideDialog ? "Save & Close" : "Save"}`}</Button>
          : null}
        {this.state.currentIndex < this.props.config.steps.length - 1
          ? <Button
            variant={"contained"}
            disabled={!this.props.draft && this.state.hasUnfilledRequiredItems}
            onClick={() => this.setState({currentIndex: this.state.currentIndex + 1})}>Next</Button>
          : null}
        {this.state.currentIndex === this.props.config.steps.length - 1
          ? <Button
            variant={"contained"}
            onClick={() => {
              if (this.props.hideDialog) {
                BaseApp.CONTEXT.hideDialog();
              }
              this.props.config.finishAction.onClick();
            }}>
            {this.props.config.finishAction.text}
          </Button>
          : null}
      </StyledBoxRow>
    </StyledBoxColumn>;
  }
}